var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.7 2 2 4.7 2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2ZM8 3.33333C9.03333 3.33333 10 3.7 10.8 4.26667L4.26667 10.8C3.7 10 3.33333 9.03333 3.33333 8C3.33333 5.43333 5.43333 3.33333 8 3.33333ZM8 12.6667C6.96667 12.6667 6 12.3 5.2 11.7333L11.7333 5.2C12.3 6 12.6667 6.96667 12.6667 8C12.6667 10.5667 10.5667 12.6667 8 12.6667Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c7c4f2721252600de2373c77e1b39681.svg";
export { ForwardRef as ReactComponent };